import EmailDisplayMode from "@/domain/enums/EmailDisplayMode";
import {
    EmailDisplayMode as EmailDisplayModeSDK,
    useUserSettings,
} from "@cs_teamwaydev/mailvista-sdk_react";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import useGetUserProfile from "../useGetUserProfile";
import useErrorToast from "../utils/useErrorToast";

const useSetDisplayModeSetting = () => {
    const { setUserEmailDisplayMode } = useUserSettings();
    const showToast = useErrorToast();
    const { t } = useTranslation();
    const { data: user } = useGetUserProfile();

    const setDisplayModeMutation = useMutation({
        mutationFn: async (displayMode: EmailDisplayMode): Promise<void> => {
            if (!user) {
                throw new Error("User is not available");
            }

            await setUserEmailDisplayMode(displayMode as EmailDisplayModeSDK);
        },
        onError: (err) => {
            console.error("Error setting display mode", err);

            showToast({
                titleTranslationKey: t("errors.displayModeSettings"),
            });
        },
    });

    return {
        setDisplayMode: setDisplayModeMutation.mutate,
        isLoading: setDisplayModeMutation.isPending,
        error: setDisplayModeMutation.error,
    };
};

export default useSetDisplayModeSetting;
